import { useLanguage } from "../../../../stores/LanguageStore";
import { Button, Divider, Group, Stack, Text, Title } from "@mantine/core";

const OvhStepFinished = ({
  domain,
  emails,
  buyDomain,
  handleClose,
  onFinish,
}) => {
  const lang = useLanguage((s) => s.language);
  const handleFinish = () => {
    handleClose();
    onFinish();
  };

  return (
    <Stack mt={20} justify="center" align="center">
      <Title order={2} c={"green.8"}>
        {lang.ovh.finished.title}
      </Title>
      <Text size="lg">{lang.ovh.finished.text_summary}</Text>

      <Stack
        gap={"xs"}
        style={{ border: "1px solid #00000016", borderRadius: 8 }}
        p={16}
      >
        {buyDomain && (
          <>
            <Text size="lg">
              {lang.ovh.step4.domain}
              <span
                style={{
                  color: "var(--mantine-color-primary-6)",
                  marginLeft: 16,
                  fontWeight: 600,
                  fontSize: 16,
                }}
              >
                {domain}
              </span>
            </Text>

            {emails.length > 0 && <Divider />}
          </>
        )}
        {emails.length > 0 && (
          <>
            <Text size="lg">{lang.ovh.step4.emails}</Text>
            {emails.map((email, index) => (
              <Group
                key={email.id}
                style={{ border: "1px solid #00000016", borderRadius: 8 }}
                p={"sm"}
              >
                <Text size="lg">
                  {email.prefix}@{domain}
                </Text>
              </Group>
            ))}
          </>
        )}
        {emails.length > 0 && (
          <Text size="lg" fw={500} mt={16}>
            {lang.ovh.finished.emails_info}
          </Text>
        )}
      </Stack>

      <Group justify="center" gap={32} mb={16}>
        <Button size="md" onClick={handleFinish} w={300}>
          {lang.ovh.finished.finish}
        </Button>
      </Group>
    </Stack>
  );
};

export default OvhStepFinished;
